// extracted by mini-css-extract-plugin
module.exports = {"newsContainer":"NewsSection_newsContainer__wzb6x"};